import {
  AdvancedTableHeader,
  DynamicDataField,
  LabelElement,
} from '../../types';

export const SALES_ORDER_FIELDS: DynamicDataField[] = [
  // Billing Information
  {
    value: 'billToAttention',
    label: 'Bill To Attention',
    group: 'Billing Information',
  },
  { value: 'billToCity', label: 'Bill To City', group: 'Billing Information' },
  {
    value: 'billToCompanyName',
    label: 'Bill To Company Name',
    group: 'Billing Information',
  },
  {
    value: 'billToCountry',
    label: 'Bill To Country',
    group: 'Billing Information',
  },
  {
    value: 'billToEmail',
    label: 'Bill To Email',
    group: 'Billing Information',
  },
  { value: 'billToName', label: 'Bill To Name', group: 'Billing Information' },
  {
    value: 'billToPhone',
    label: 'Bill To Phone',
    group: 'Billing Information',
  },
  {
    value: 'billToPostalCode',
    label: 'Bill To Postal Code',
    group: 'Billing Information',
  },
  {
    value: 'billToResidential',
    label: 'Bill To Residential Address',
    group: 'Billing Information',
  },
  {
    value: 'billToState',
    label: 'Bill To State/Province',
    group: 'Billing Information',
  },
  {
    value: 'billToStreet',
    label: 'Bill To Street',
    group: 'Billing Information',
  },
  {
    value: 'billToStreet2',
    label: 'Bill To Street 2',
    group: 'Billing Information',
  },

  // Currency Information
  {
    value: 'exchangeCurrency.code',
    label: 'Exchange Currency Code',
    group: 'Currency Information',
  },
  {
    value: 'exchangeCurrency.country',
    label: 'Exchange Currency Country',
    group: 'Currency Information',
  },
  {
    value: 'homeCurrency.code',
    label: 'Home Currency Code',
    group: 'Currency Information',
  },
  {
    value: 'homeCurrency.country',
    label: 'Home Currency Country',
    group: 'Currency Information',
  },

  // Customer Information
  {
    value: 'customer.name',
    label: 'Customer Name',
    group: 'Customer Information',
  },
  {
    value: 'customer.email',
    label: 'Customer Email',
    group: 'Customer Information',
  },
  {
    value: 'customer.phone',
    label: 'Customer Phone',
    group: 'Customer Information',
  },
  {
    value: 'customer.bcc',
    label: 'Customer BCC',
    group: 'Customer Information',
  },
  {
    value: 'customer.currency.code',
    label: 'Customer Currency Code',
    group: 'Customer Information',
  },
  {
    value: 'customer.currency.country',
    label: 'Customer Currency Country',
    group: 'Customer Information',
  },
  {
    value: 'customer.url',
    label: 'Customer URL',
    group: 'Customer Information',
  },
  {
    value: 'customer.mobile',
    label: 'Customer Mobile',
    group: 'Customer Information',
  },

  // Location
  {
    value: 'location.name',
    label: 'Location Name',
    group: 'Location',
  },
  {
    value: 'location.type',
    label: 'Location Type',
    group: 'Location',
  },
  {
    value: 'location.description',
    label: 'Location Description',
    group: 'Location',
  },

  // Location Address
  {
    value: 'location.address.attention',
    label: 'Location Attention',
    group: 'Location Address',
  },
  {
    value: 'location.address.city',
    label: 'Location City',
    group: 'Location Address',
  },
  {
    value: 'location.address.country',
    label: 'Location Country',
    group: 'Location Address',
  },
  {
    value: 'location.address.postalCode',
    label: 'Location Postal Code',
    group: 'Location Address',
  },
  {
    value: 'location.address.state',
    label: 'Location State/Province',
    group: 'Location Address',
  },
  {
    value: 'location.address.street',
    label: 'Location Street',
    group: 'Location Address',
  },
  {
    value: 'location.address.street2',
    label: 'Location Street 2',
    group: 'Location Address',
  },

  // Order Details
  { value: 'id', label: 'Order ID', group: 'Order Details' },
  { value: 'number', label: 'Order Number', group: 'Order Details' },
  { value: 'status', label: 'Order Status', group: 'Order Details' },
  { value: 'dateCreated', label: 'Date Created', group: 'Order Details' },
  { value: 'dateScheduled', label: 'Date Scheduled', group: 'Order Details' },
  {
    value: 'customerPONumber',
    label: 'Customer PO Number',
    group: 'Order Details',
  },
  { value: 'carrier.name', label: 'Carrier', group: 'Order Details' },
  { value: 'paymentTermId', label: 'Payment Term ID', group: 'Order Details' },
  {
    value: 'shippingTermId',
    label: 'Shipping Term ID',
    group: 'Order Details',
  },
  { value: 'priorityId', label: 'Priority ID', group: 'Order Details' },
  { value: 'salesTaxId', label: 'Sales Tax ID', group: 'Order Details' },
  {
    value: 'representative',
    label: 'Sales Representative',
    group: 'Order Details',
  },
  { value: 'phone', label: 'Order Phone', group: 'Order Details' },
  { value: 'notes', label: 'Order Notes', group: 'Order Details' },

  // Order Totals
  { value: 'subTotal', label: 'Subtotal', group: 'Order Totals' },
  { value: 'taxTotal', label: 'Tax Total', group: 'Order Totals' },
  { value: 'grandTotal', label: 'Grand Total', group: 'Order Totals' },
  { value: 'paymentTotal', label: 'Payment Total', group: 'Order Totals' },
  { value: 'total', label: 'Overall Total', group: 'Order Totals' },
  {
    value: 'orderLevelDiscountFlatAmount',
    label: 'Order Discount Amount',
    group: 'Order Totals',
  },
  {
    value: 'orderLevelDiscountPercent',
    label: 'Order Discount Percent',
    group: 'Order Totals',
  },
  { value: 'marginPercent', label: 'Margin Percent', group: 'Order Totals' },
  { value: 'markupPercent', label: 'Markup Percent', group: 'Order Totals' },

  // Multi-Currency Order Totals
  {
    value: 'multiCurrencySubtotal',
    label: 'Subtotal',
    group: 'Multi-Currency Order Totals',
  },
  {
    value: 'multiCurrencyTaxTotal',
    label: 'Tax Total',
    group: 'Multi-Currency Order Totals',
  },
  {
    value: 'multiCurrencyGrandTotal',
    label: 'Total',
    group: 'Multi-Currency Order Totals',
  },
  {
    value: 'multiCurrencyPaymentTotal',
    label: 'Payment Total',
    group: 'Multi-Currency Order Totals',
  },
  {
    value: 'multiCurrencyDiscountTotal',
    label: 'Discount Total',
    group: 'Multi-Currency Order Totals',
  },
  {
    value: 'multiCurrencyOrderLevelDiscountTotal',
    label: 'Order Level Discount Total',
    group: 'Multi-Currency Order Totals',
  },

  // Shipping Information
  {
    value: 'shipToAttention',
    label: 'Ship To Attention',
    group: 'Shipping Information',
  },
  { value: 'shipToCity', label: 'Ship To City', group: 'Shipping Information' },
  {
    value: 'shipToCompanyName',
    label: 'Ship To Company Name',
    group: 'Shipping Information',
  },
  {
    value: 'shipToCountry',
    label: 'Ship To Country',
    group: 'Shipping Information',
  },
  {
    value: 'shipToEmail',
    label: 'Ship To Email',
    group: 'Shipping Information',
  },
  { value: 'shipToName', label: 'Ship To Name', group: 'Shipping Information' },
  {
    value: 'shipToPhone',
    label: 'Ship To Phone',
    group: 'Shipping Information',
  },
  {
    value: 'shipToPostalCode',
    label: 'Ship To Postal Code',
    group: 'Shipping Information',
  },
  {
    value: 'shipToResidential',
    label: 'Ship To Residential Address',
    group: 'Shipping Information',
  },
  {
    value: 'shipToState',
    label: 'Ship To State/Province',
    group: 'Shipping Information',
  },
  {
    value: 'shipToStreet',
    label: 'Ship To Street',
    group: 'Shipping Information',
  },
  {
    value: 'shipToStreet2',
    label: 'Ship To Street 2',
    group: 'Shipping Information',
  },
];

export const AVAILABLE_ADVANCED_TABLE_COLUMNS: AdvancedTableHeader[] = [
  { key: 'cityTaxAmount', label: 'City Tax Amount' },
  { key: 'cityTaxRate', label: 'City Tax Rate' },
  { key: 'cost', label: 'Cost' },
  { key: 'countyTaxAmount', label: 'County Tax Amount' },
  { key: 'countyTaxRate', label: 'County Tax Rate' },
  { key: 'deleted', label: 'Deleted' },
  { key: 'description', label: 'Description' },
  { key: 'discountTotal', label: 'Discount Total' },
  {
    key: 'exchangeCurrencyCode',
    label: 'Exch. Currency Code',
    path: 'exchangeCurrency.code',
  },
  {
    key: 'exchangeCurrencyCountry',
    label: 'Exch. Currency Country',
    path: 'exchangeCurrency.country',
  },
  {
    key: 'exchangeCurrencyName',
    label: 'Exch. Currency Name',
    path: 'exchangeCurrency.name',
  },
  { key: 'exchangeCurrencyId', label: 'Exchange Currency ID' },
  { key: 'exchangeRate', label: 'Exchange Rate' },
  { key: 'discount', label: 'Discount' },
  {
    key: 'salesOrderItemType',
    label: 'Type',
  },
  { key: 'sku', label: 'SKU', path: 'saleItem.sku' },
  { key: 'tags', label: 'Tags', path: 'saleItem.tags' },
  { key: 'total', label: 'Total' },
  { key: 'multiCurrencyDiscountTotal', label: 'Multi-Currency Discount Total' },
  { key: 'multiCurrencyItemPrice', label: 'Multi-Currency Item Price' },
  { key: 'multiCurrencySubTotal', label: 'Multi-Currency SubTotal' },
  { key: 'multiCurrencyTaxTotal', label: 'Multi-Currency Tax Total' },
  { key: 'multiCurrencyTotal', label: 'Multi-Currency Total' },
  { key: 'name', label: 'Name' },
  { key: 'notes', label: 'Notes' },
  { key: 'taxRate', label: 'Overall Tax Rate' },
  { key: 'price', label: 'Price' },
  { key: 'quantity', label: 'Qty' },
  { key: 'specialDistrictTaxAmount', label: 'Special District Tax Amount' },
  { key: 'specialDistrictTaxRate', label: 'Special District Tax Rate' },
  { key: 'stateTaxAmount', label: 'State Tax Amount' },
  { key: 'stateTaxRate', label: 'State Tax Rate' },
  { key: 'subTotal', label: 'SubTotal' },
  { key: 'tax', label: 'Tax' },
  { key: 'taxable', label: 'Taxable' },
  { key: 'uomId', label: 'UOM ID' },
];

export const COMMON_RENDERED_TYPES: LabelElement['type'][] = [
  'text',
  'box',
  'line',
  'barcode',
  'qrcode',
  'image',
];
